import { getBffBaseUrl } from '../utils/bffBaseUrl';

const CONFIG = {
  BASE_URL: getBffBaseUrl(),
};

export default CONFIG;
